module.exports = __webpack_public_path__ + "static/img/ABUIABACGAAg1b7xkQYopI3n_gYwwAI48AE.78f1d04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ABUIABACGAAg1b7xkQYopI3n_gYwwAI48AE.jpg
// module id = K1U0
// module chunks = 1